export const SupportedScopesOperations = {
  table_header: "Supported Scope Definitions",
  table_columns: ["Scope Name", "Grants"],
  table_data: [
    {
      "values": [
        {
          "type": "text",
          "value": "patient/*read"
        },
        {
          "type": "text",
          "value": "Permission to read and search any resource for the current patient"
        }
      ]
    },
    {
      "values": [
        {
          "type": "text",
          "value": "launch/patient"
        },
        {
          "type": "text",
          "value": "When launching outside the EHR, ask for a patient to be selected at launch time"
        }
      ]
    },
    {
      "values": [
        {
          "type": "text",
          "value": "offline_access"
        },
        {
          "type": "text",
          "value": "	Request a refresh_token that can be used to obtain a new access token to replace an expired one, even after the end-user no longer is online after the access token expires."
        }
      ]
    },
    {
      "values": [
        {
          "type": "text",
          "value": "openid fhiruser"
        },
        {
          "type": "text",
          "value": "Permission to retrieve information about the current logged-in user"
        }
      ]
    },
    {
      "values": [
        {
          "type": "text",
          "value": "openid profile"
        },
        {
          "type": "text",
          "value": "Requests access to the End-User's default profile Claims, which are: name, family_name, given_name, middle_name, nickname, preferred_username, profile, picture, website, gender, birthdate, zoneinfo, locale, and updated_at"
        }
      ]
    }
  ]
};
